module.exports = __webpack_public_path__ + "img/wei3.4fd596eb.jpg";